export let ManualPaymentModalLayoutJSON = [
  {
    name: "Manual Payment",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412415059,
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412315194,
                elementtype: "customSelect",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412308306,
                elementtype: "number",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412405877,
                elementtype: "customDate",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412415058,
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "col-2",
                elementid: 1717412274041,
                elementtype: "file",
              },
            ],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [
              {
                parentid: "col-1",
                elementid: 1717412387761,
                elementtype: "textarea",
              },
            ],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      {
        child: [
          {
            child: [],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [],
            colpos: 2,
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        elementtype: "columns",
        colsize: 2,
      },
      // {
      //   child: [
      //     {
      //       child: [
      //         {
      //           parentid: "col-1",
      //           elementid: 1717412405877,
      //           elementtype: "documentFile",
      //         },
      //       ],
      //       colpos: 1,
      //       elementtype: "column",
      //       colsizeclass: "col-md-12",
      //     },

      //   ],
      //   elementtype: "columns",
      //   colsize: 2,
      // },
      // {
      //   child: [

      //     {
      //       child: [
      //         {
      //           parentid: "col-2",
      //           elementid: 1717412292824,
      //           elementtype: "documentFile",
      //         },
      //       ],
      //       colpos: 2,
      //       elementtype: "column",
      //       colsizeclass: "col-md-12",
      //     },
      //   ],
      //   elementtype: "columns",
      //   colsize: 2,
      // },
      {
        child: [
          {
            child: [],
            colpos: 1,
            elementtype: "column",
            colsizeclass: "col-md-12",
          },
        ],
        elementtype: "columns",
        colsize: 1,
      },
    ],
  },
];
